type Language = 'cs' | 'en'

import { clearSpaces } from '../../string/clearSpaces'

export interface IntlNumberFormatOptions extends Intl.NumberFormatOptions {
  lang?: Language
}

const numberFormatInternal = (value: number, options: IntlNumberFormatOptions) =>
  new Intl.NumberFormat(options.lang ?? 'cs', options).format(value)

export const numberFormat = (
  value: number | string,
  options: IntlNumberFormatOptions = {
    lang: 'cs',
    minimumFractionDigits: 0
  }
): string => {
  if (typeof value === 'string') {
    const clearFormatted = clearSpaces(value).replaceAll(',', '.')
    return clearFormatted.length === 0 || isNaN(+clearFormatted) ? '' : numberFormatInternal(+clearFormatted, options)
  }

  return numberFormatInternal(value, options)
}
